import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PurchaseTags } from '@shared/purchase-tags/service-level-tag.component';
import { PurchaseStatus, ROLES_KEYS, User, UserProcessStatus } from '@interfaces';
import { ReplaySubject, Subject } from 'rxjs';
import { UserAssetsFacade } from '@state/user-assets';
import { AnalyticsService } from '@core/services/analytics.service';
import { AvailableLanguages } from '@constants';
import { PurchaseFacade } from '@state/purchase';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-settings-transactions',
  templateUrl: './user-settings-transactions.component.html',
  styleUrls: ['./user-settings-transactions.component.scss'],
})
export class UserSettingsTransactionsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new ReplaySubject(1);

  @Input() myself: User;
  @Input() currentLang: AvailableLanguages;

  public showPurchaseList = false;
  public purchaseList$ = this.purchaseFacade.purchaseList$;
  public loadingPurchaseList$ = this.purchaseFacade.loadingPurchaseList$;
  public PurchaseStatus = PurchaseStatus;
  public UserProcessStatus = UserProcessStatus;

  protected readonly PurchaseTags = PurchaseTags;

  constructor(
    private readonly userAssets: UserAssetsFacade,
    private readonly analyticsService: AnalyticsService,
    private readonly purchaseFacade: PurchaseFacade
  ) {}

  public ngOnInit(): void {
    if (this.myself?.role.key === ROLES_KEYS.Foreigner && this.myself?.company.purchaseEnabled) {
      this.purchaseFacade.getMyPurchaseList();
    }

    this.purchaseFacade.getMyPurchaseListSuccess$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.showPurchaseList = true;
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public downloadPurchaseDocument(userAssetId: string): void {
    this.userAssets.downloadMyAsset(userAssetId);
    this.analyticsService.trackEvent('user_event', 'user_download_purchase_document');
  }
}
